import {Injectable} from '@angular/core';
import authData from './mock-data/auth.json';
import analyticsCustomVarsData from './mock-data/analytics-custom-vars.json';
import serviceProviderData from './mock-data/service-provider.json';
import pageDefault from './mock-data/pageDefault.json';
import type {HttpRequest} from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class MockDataService {
    getMockData(request: HttpRequest<any>) {
        const url: URL = new URL(request.url);
        const endpoint: string = url.pathname;

        switch (endpoint) {
            case '/service-provider/2':
                return serviceProviderData;
            case '/auth':
                return this.parseMockData(authData);
            case '/analytics-custom-vars':
                return analyticsCustomVarsData;
            case '/page/default':
                return pageDefault;
            case '/ping':
                return 900;
            default:
                console.log(
                    '❗️ This endpoint is not being intercepted by the mock service:',
                    endpoint
                );
                return null;
        }
    }

    private parseMockData(data: any) {
        for (const [key, value] of Object.entries(data)) {
            switch (value) {
                case '*FIRSTNAME*':
                    data[key] = this.getRandomData(['Geoff', 'Helga', 'Bertie', 'Ethel', 'Julie', 'Jeremy']);
                    break;
            }
        }
        if (data.data) {
            this.parseMockData(data.data);
        }

        return data;
    }

    private getRandomData(array: string[]) {
        return array[Math.floor(Math.random() * array.length)];
    }

    // private getRandomInt(max?: number): number {
    //     return Math.floor(Math.random() * (max ?? 500));
    // }

}
